var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ds-control mobile dsf_teas_attendance_detail" },
    [
      _c(
        "div",
        { staticClass: "search" },
        [
          _c("van-search", {
            attrs: { shape: "round", placeholder: "搜索" },
            on: { input: _vm.search },
            model: {
              value: _vm.keywords,
              callback: function ($$v) {
                _vm.keywords = $$v
              },
              expression: "keywords",
            },
          }),
        ],
        1
      ),
      _c("div", { staticClass: "top_statistics" }, [
        _vm.systemArr.length &&
        _vm.systemArr.length !== 1 &&
        _vm.systemArr.length !== 5
          ? _c("div", { staticClass: "attendance_rank" }, [
              _c("span", [_vm._v(_vm._s(_vm.totalObj.attendRate) + "%")]),
              _c("div", [_vm._v("考勤率")]),
            ])
          : _vm._e(),
        _c(
          "div",
          {
            staticClass: "other_rank",
            class: [
              !_vm.systemArr.length ||
              _vm.systemArr.length == 1 ||
              _vm.systemArr.length == 5
                ? "other_width"
                : "",
            ],
          },
          [
            !_vm.systemArr.length ||
            _vm.systemArr.length == 1 ||
            _vm.systemArr.length == 5
              ? _c("div", { staticClass: "attendance" }, [
                  _c("span", [_vm._v(_vm._s(_vm.totalObj.attendRate) + "%")]),
                  _c("div", [_vm._v("考勤率")]),
                ])
              : _vm._e(),
            _c("div", [
              _c(
                "div",
                {
                  staticClass: "statistics_item",
                  class: [!_vm.chooseValue ? "choose_value" : ""],
                  on: {
                    click: function ($event) {
                      return _vm.changeBtn("")
                    },
                  },
                },
                [
                  _c("span", [_vm._v(_vm._s(_vm.totalObj.should))]),
                  _c("div", [_vm._v("应到")]),
                ]
              ),
            ]),
            _vm.systemArr.includes("1")
              ? _c("div", [
                  _c(
                    "div",
                    {
                      staticClass: "statistics_item",
                      class: [_vm.chooseValue == "1" ? "choose_value" : ""],
                      on: {
                        click: function ($event) {
                          return _vm.changeBtn("1")
                        },
                      },
                    },
                    [
                      _c("span", [_vm._v(_vm._s(_vm.totalObj.onTime))]),
                      _c("div", [_vm._v("出勤")]),
                    ]
                  ),
                ])
              : _vm._e(),
            _c("div", [
              _c(
                "div",
                {
                  staticClass: "statistics_item",
                  class: [_vm.chooseValue == "6,7,8" ? "choose_value" : ""],
                  on: {
                    click: function ($event) {
                      return _vm.changeBtn("6,7,8")
                    },
                  },
                },
                [
                  _c("span", [_vm._v(_vm._s(_vm.totalObj.leave))]),
                  _c("div", [_vm._v("请假")]),
                ]
              ),
            ]),
            _vm.systemArr.includes("2")
              ? _c("div", [
                  _c(
                    "div",
                    {
                      staticClass: "statistics_item",
                      class: [_vm.chooseValue == "2" ? "choose_value" : ""],
                      on: {
                        click: function ($event) {
                          return _vm.changeBtn("2")
                        },
                      },
                    },
                    [
                      _c("span", [_vm._v(_vm._s(_vm.totalObj.late))]),
                      _c("div", [_vm._v("迟到")]),
                    ]
                  ),
                ])
              : _vm._e(),
            _vm.systemArr.includes("3")
              ? _c("div", [
                  _c(
                    "div",
                    {
                      staticClass: "statistics_item",
                      class: [_vm.chooseValue == "3" ? "choose_value" : ""],
                      on: {
                        click: function ($event) {
                          return _vm.changeBtn("3")
                        },
                      },
                    },
                    [
                      _c("span", [_vm._v(_vm._s(_vm.totalObj.seriousLate))]),
                      _c("div", [_vm._v("晚到")]),
                    ]
                  ),
                ])
              : _vm._e(),
            _vm.systemArr.includes("4")
              ? _c("div", [
                  _c(
                    "div",
                    {
                      staticClass: "statistics_item",
                      class: [_vm.chooseValue == "4" ? "choose_value" : ""],
                      on: {
                        click: function ($event) {
                          return _vm.changeBtn("4")
                        },
                      },
                    },
                    [
                      _c("span", [_vm._v(_vm._s(_vm.totalObj.early))]),
                      _c("div", [_vm._v("早退")]),
                    ]
                  ),
                ])
              : _vm._e(),
            _c("div", [
              _c(
                "div",
                {
                  staticClass: "statistics_item",
                  class: [_vm.chooseValue == "9" ? "choose_value" : ""],
                  on: {
                    click: function ($event) {
                      return _vm.changeBtn("9")
                    },
                  },
                },
                [
                  _c("span", [_vm._v(_vm._s(_vm.totalObj.notSign))]),
                  _c("div", [_vm._v("未签")]),
                ]
              ),
            ]),
          ]
        ),
      ]),
      _vm.showSelect
        ? _c(
            "div",
            { staticClass: "all_select", on: { click: _vm.allSelect } },
            [
              _c("van-checkbox", {
                model: {
                  value: _vm.allCheck,
                  callback: function ($$v) {
                    _vm.allCheck = $$v
                  },
                  expression: "allCheck",
                },
              }),
              _vm._v(" 全选(已选 " + _vm._s(_vm.selectNum) + " 人) "),
            ],
            1
          )
        : _vm._e(),
      _vm.list.length > 0
        ? _c(
            "div",
            { staticClass: "list" },
            [
              _c(
                "van-pull-refresh",
                {
                  on: { refresh: _vm.onRefresh },
                  model: {
                    value: _vm.refreshing,
                    callback: function ($$v) {
                      _vm.refreshing = $$v
                    },
                    expression: "refreshing",
                  },
                },
                [
                  _c(
                    "van-list",
                    {
                      attrs: {
                        finished: _vm.finished,
                        "finished-text": "没有更多了",
                        error: _vm.error,
                      },
                      on: {
                        "update:error": function ($event) {
                          _vm.error = $event
                        },
                        load: _vm.getList,
                      },
                      model: {
                        value: _vm.loading,
                        callback: function ($$v) {
                          _vm.loading = $$v
                        },
                        expression: "loading",
                      },
                    },
                    _vm._l(_vm.list, function (item, index) {
                      return _c(
                        "DsfMobileTeasCell",
                        {
                          key: index,
                          staticClass: "list-item",
                          attrs: {
                            border: "",
                            headerUrl: item.photo || _vm.defaultImg,
                            cellShape: "square",
                            title: item.name,
                          },
                          nativeOn: {
                            click: function ($event) {
                              return _vm.itemClick(item, index)
                            },
                          },
                        },
                        [
                          _vm.showSelect
                            ? _c(
                                "div",
                                {
                                  staticClass: "radio_value",
                                  attrs: { slot: "front" },
                                  slot: "front",
                                },
                                [
                                  _c("van-checkbox", {
                                    model: {
                                      value: item.radioValue,
                                      callback: function ($$v) {
                                        _vm.$set(item, "radioValue", $$v)
                                      },
                                      expression: "item.radioValue",
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                          _c("DsfMobileTeasCellItem", {
                            attrs: { value: item.groupText || "暂无" },
                          }),
                          _c("DsfMobileTeasCellItem", {
                            attrs: { value: item.job || "暂无" },
                          }),
                          !_vm.showSelect
                            ? _c(
                                "div",
                                {
                                  staticClass: "status",
                                  class: {
                                    chuqin: item.resultValue === "1",
                                    gongjia:
                                      "678".indexOf(item.resultValue) !== -1,
                                    weiqian:
                                      "1678".indexOf(item.resultValue) === -1,
                                  },
                                  attrs: { slot: "titleRight" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.changeStatus(item.userId)
                                    },
                                  },
                                  slot: "titleRight",
                                },
                                [_vm._v(" " + _vm._s(item.resultText) + " ")]
                              )
                            : _vm._e(),
                        ],
                        1
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
              _c("div", { staticClass: "zw_div" }),
              _c("div", { staticClass: "all_btn" }, [
                !_vm.showSelect
                  ? _c(
                      "div",
                      {
                        staticClass: "batch",
                        on: { click: _vm.batchOperation },
                      },
                      [_vm._v("批量操作")]
                    )
                  : _vm._e(),
                _vm.showSelect
                  ? _c(
                      "div",
                      {
                        staticClass: "cancel",
                        on: { click: _vm.cancelSelect },
                      },
                      [_vm._v("取消")]
                    )
                  : _vm._e(),
                _vm.showSelect
                  ? _c(
                      "div",
                      {
                        staticClass: "modify",
                        on: { click: _vm.modifySelect },
                      },
                      [_vm._v("修改状态")]
                    )
                  : _vm._e(),
              ]),
            ],
            1
          )
        : _c("van-empty", { attrs: { description: "暂无数据" } }),
      _c(
        "van-popup",
        {
          attrs: { round: "", position: "bottom" },
          model: {
            value: _vm.showStatus,
            callback: function ($$v) {
              _vm.showStatus = $$v
            },
            expression: "showStatus",
          },
        },
        [
          _c("van-picker", {
            attrs: { "show-toolbar": "", columns: _vm.statusOption },
            on: {
              cancel: function ($event) {
                _vm.showStatus = false
              },
              confirm: _vm.onConfirm,
            },
          }),
        ],
        1
      ),
      _c(
        "van-dialog",
        {
          attrs: {
            "show-confirm-button": false,
            "close-on-click-overlay": "",
            width: "300px",
          },
          model: {
            value: _vm.showQrCode,
            callback: function ($$v) {
              _vm.showQrCode = $$v
            },
            expression: "showQrCode",
          },
        },
        [
          _c("div", { staticClass: "dialog_head" }, [
            _c("i", {
              staticClass: "iconfont icon-guanbi3",
              on: {
                click: function ($event) {
                  _vm.showQrCode = false
                },
              },
            }),
          ]),
          _c("div", { staticClass: "dialog_content" }, [
            _c("p", { staticClass: "title" }, [_vm._v("考勤二维码")]),
            _c("img", { attrs: { src: _vm.qrCodeSrc } }),
            _c("div", { staticClass: "value" }, [
              _c("span", [_vm._v(_vm._s(_vm.timerNum))]),
              _vm._v("秒后刷新"),
            ]),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }